import type { MergeOutput } from './types';

export default function deepNestedMerge<T extends Record<string, any>>(
  target: T,
  source: unknown,
): T {
  if (typeof target !== 'object' || target === null) return source as T;
  if (typeof source !== 'object' || source === null) return target;

  const output = Array.isArray(target) ? [...target] : { ...target };

  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      (output as MergeOutput)[key] = deepNestedMerge(target[key], (source as T)[key]);
    }
  }

  return output as T;
}
